/**
 * Read-only device preview for destination transfer review (stacked above transfer modal).
 */

import React from 'react';
import ReactDOM from 'react-dom';
import DeviceView from '../../devices/components/DeviceView';
import ModalCloseButton from '../../../shared/components/modals/ModalCloseButton';
import './TransferDeviceViewModal.css';

const TransferDeviceViewModal = ({ transferId, deviceId, token, user, onClose }) =>
  ReactDOM.createPortal(
    <div className="transfer-device-view-overlay" onClick={onClose} role="presentation">
      <div
        className="transfer-device-view-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Device details (read-only)"
      >
        <div className="transfer-device-view-panel-header">
          <h2>Device details (read-only)</h2>
          <ModalCloseButton onClick={onClose} title="Close" />
        </div>
        <div className="transfer-device-view-panel-body">
          <DeviceView
            deviceId={deviceId}
            transferPreviewId={transferId}
            token={token}
            user={user}
            onClose={onClose}
            previewInModal
          />
        </div>
      </div>
    </div>,
    document.body
  );

export default TransferDeviceViewModal;
